<span class="inline-flex items-center justify-center max-w-48 break-all min-w-8" *ngIf="options" (click)="enableClick && onClick()"
    [ngStyle]="getBadgeStyles()" [ngClass]="customClass"> 
    <i *ngIf="options?.icon && options?.icon.length && !options?.url" [ngClass]="options?.icon"></i>
    <ng-container *ngIf="options?.icon && options?.icon.length && options?.url">
        <img [src]="options.icon" alt="" loading="lazy" class="mr-2 w-4 h-6">
    </ng-container>
    <span class="mt-0.5 truncate">{{options.displayKey ? (options.displayKey | translate) : options.displayName}} </span>
</span>